import { useNavigate, useLocation } from "react-router-dom";

export function MarketingFooter() {
  const navigate = useNavigate();
  const location = useLocation();
  const year = new Date().getFullYear();

  const goSection = (id) => {
    if (location.pathname === "/") {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      navigate("/", { state: { scrollTo: id } });
    }
  };

  return (
    <footer className="cline-t" data-testid="marketing-footer" style={{ background: "var(--surface)" }}>
      <div style={{ maxWidth: 1140, margin: "0 auto", padding: "44px 22px 36px" }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 40, justifyContent: "space-between" }}>
          <div style={{ maxWidth: 320 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <img src="/hdg-logo.jpg" alt="HeyDesignGuy" style={{ height: 30, width: 30, objectFit: "contain", borderRadius: 7, background: "#fff", padding: 3 }} />
              <span className="font-display" style={{ fontWeight: 700, fontSize: 15, color: "var(--tprimary)" }}>HDG Creative Studio</span>
            </div>
            <p className="font-body" style={{ fontSize: 13, color: "var(--tsecondary)", marginTop: 14, lineHeight: 1.6 }}>
              Agency-caliber brand thinking, powered by AI. Paste a URL. Watch your brand come to life.
            </p>
          </div>

          <div style={{ display: "flex", gap: 56, flexWrap: "wrap" }}>
            <div>
              <div className="font-mono" style={{ fontSize: 11, color: "var(--tmuted)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 14 }}>Product</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                <button onClick={() => goSection("how")} className="app-link font-body" style={{ background: "none", border: "none", cursor: "pointer", fontSize: 13, textAlign: "left", padding: 0 }}>How it works</button>
                <button onClick={() => goSection("pricing")} className="app-link font-body" style={{ background: "none", border: "none", cursor: "pointer", fontSize: 13, textAlign: "left", padding: 0 }}>Pricing</button>
                <button onClick={() => navigate("/start")} className="app-link font-body" style={{ background: "none", border: "none", cursor: "pointer", fontSize: 13, textAlign: "left", padding: 0 }}>Start free</button>
              </div>
            </div>
            <div>
              <div className="font-mono" style={{ fontSize: 11, color: "var(--tmuted)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 14 }}>Company</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                <button onClick={() => navigate("/about-us")} className="app-link font-body" style={{ background: "none", border: "none", cursor: "pointer", fontSize: 13, textAlign: "left", padding: 0 }}>About us</button>
                <button onClick={() => navigate("/login")} className="app-link font-body" style={{ background: "none", border: "none", cursor: "pointer", fontSize: 13, textAlign: "left", padding: 0 }}>Log in</button>
                <a href="https://heydesignguy.com" target="_blank" rel="noreferrer" className="app-link font-body" style={{ fontSize: 13 }}>heydesignguy.com</a>
              </div>
            </div>
          </div>
        </div>

        <div className="cline-t" style={{ marginTop: 36, paddingTop: 20, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
          <span className="font-body" style={{ fontSize: 12, color: "var(--tmuted)" }}>© {year} HeyDesignGuy. All rights reserved.</span>
          <span className="font-mono" style={{ fontSize: 11, color: "var(--tmuted)" }}>Educator. Challenger. Architect.</span>
        </div>
      </div>
    </footer>
  );
}
